if (typeof AFRAME === 'undefined') {
  throw new Error('Component attempted to register before AFRAME was available.');
}

AFRAME.registerComponent('ui-console', {
  schema: {
    product: {
      type: 'string',
      default: ''
    },
    rig: {
      type: 'string',
      default: '#cameraRig'
    },
    radius: {
      type: 'number',
      default: 0.75
    },
    triggered: {
      type: 'boolean',
      default: false
    },
  },

  init: function () {
    var data = this.data;
    var el = this.el;
    var cameraRig = document.querySelector(data.rig);
    var uiEl = this.uiEl = el.object3D.parent;
    var rigEl = this.rigEl = cameraRig.object3D;
//    this.hide();
  },
  tick: function (time, delta) {
    if(this.data.triggered){

    // if (this.data.product === "ucaas") {
    //   var positionX = this.rigEl.position.x;
    //   var positionZ = this.rigEl.position.z;

    //   if (positionX < 1 && positionX > -1) {
    //     var showUcaaS = true
    //   } else {
    //     showUcaaS = false;
    //   }
    // }

    // var dist = this.calcDistance(this.uiEl.position.x, this.uiEl.position.z, this.rigEl.position.x, this.rigEl.position.z);
    // if (dist < this.data.radius || showUcaaS) {
    //   if (this.el.getAttribute('visible') === false) {
    //     this.show();
    //   }
    } else {
      var dist = this.calcDistance(this.uiEl.position.x, this.uiEl.position.z, this.rigEl.position.x, this.rigEl.position.z);
      if (dist < this.data.radius) {
        if (this.el.getAttribute('visible') === false) {
          this.show();
        }
      } else {
        if (this.el.getAttribute('visible') === true) {
          this.hide();
        }
      }      
    }

  },
  calcDistance: function (x1, z1, x2, z2) {
    return Math.sqrt(Math.pow((x2 - x1), 2) + Math.pow((z2 - z1), 2));
  },
  show: function () {
    //    console.log(">>>>>>>> showing: " + this.data.product);
    this.el.setAttribute('visible', 'true');
  },
  hide: function () {
    //    console.log(">>>>>>>> hiding: " + this.data.product);
    this.el.setAttribute('visible', 'false');
  },
  update: function (oldData) {},
});



// WEBPACK FOOTER //
// ./src/aframe/components/ui-console.js